import { render, staticRenderFns } from "./ArtPlan.vue?vue&type=template&id=fa2940b4&scoped=true"
import script from "./ArtPlan.vue?vue&type=script&lang=js"
export * from "./ArtPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa2940b4",
  null
  
)

export default component.exports